<template>
  <div>
    <page-header-layout>
      <div class='main-page-content db-page'>
        <div
          v-loading='loading'
          element-loading-background='rgba(255, 255, 255, 0.01)'
          element-loading-text='拼命加载中...'
          class='db-page-body'
        >
          <el-row :gutter='15'>
            <el-col :md='24' :xs='24'>
              <el-card class='db-card' shadow='hover'>
                <template slot='header'>
                  <div class='card-header'>
                    <span class='card-title'><i class='el-icon-coin'></i>数据库信息</span>
                    <el-button type='text' icon='el-icon-refresh' :loading='loading' @click='init'>刷新</el-button>
                  </div>
                </template>
                <el-row :gutter='15' class='db-overview'>
                  <el-col :lg='6' :md='12' :sm='12' :xs='24'>
                    <div class='overview-item'>
                      <div class='overview-label'>库名</div>
                      <div class='overview-value is-text ellipsis' :title='schema_data.table_schema'>
                        {{ schema_data.table_schema || '-' }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg='6' :md='12' :sm='12' :xs='24'>
                    <div class='overview-item'>
                      <div class='overview-label'>总行数</div>
                      <div class='overview-value'>
                        {{ schema_data.table_rows != null ? numberFormat(schema_data.table_rows, 0, '.', ',') : '-' }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg='6' :md='12' :sm='12' :xs='24'>
                    <div class='overview-item'>
                      <div class='overview-label'>数据大小</div>
                      <div class='overview-value'>
                        {{ schema_data.data_size != null ? $utils.byteToSize(schema_data.data_size) : '-' }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :lg='6' :md='12' :sm='12' :xs='24'>
                    <div class='overview-item'>
                      <div class='overview-label'>索引总量</div>
                      <div class='overview-value'>
                        {{ schema_data.index_size != null ? $utils.byteToSize(schema_data.index_size) : '-' }}
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <div class='section-head'>
                  <span class='section-title'><i class='el-icon-s-grid'></i>表信息</span>
                  <span class='section-tip'><i class='el-icon-info'></i>双击行可查看指定表的数据字典</span>
                </div>
                <el-form class='db-search' :model='searchCondition' label-position='left' inline
                         @submit.native.prevent>
                  <el-form-item label='表名'>
                    <el-input v-model='searchCondition.table_name' placeholder='请输入表名搜索'
                              prefix-icon='el-icon-search' @keyup.enter.native='handleQuery' clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type='primary' icon='el-icon-search' @click='handleQuery' :disabled='loadingStatus'>
                      搜索
                    </el-button>
                  </el-form-item>
                </el-form>

                <div class='default-table db-table'>
                  <!--    渲染表格-->
                  <m-table highlight-current-row :showIndex='true' :offset='offset' max-height='500'
                           :tableData='dataList' :columns='columns' @sort-change='changeTableSort'
                           :loading='loadingStatus' @row-dblclick='handleClick' border>
                    <el-table-column label='操作项' width='260' fixed='right' align='center'>
                      <template slot-scope='{row}'>
                        <el-button type='text' icon='el-icon-tickets' @click='showTableDict(row.TABLE_NAME)'>字典
                        </el-button>
                        <el-button type='text' icon='el-icon-document-checked' @click='optimizeTable(row)'>碎片优化
                        </el-button>
                        <el-button type='text' icon='el-icon-view' @click='handlePreview(row)'>预览</el-button>
                      </template>
                    </el-table-column>
                  </m-table>
                </div>
                <!--    渲染分页-->
                <m-pagination :total.sync='total' :limit.sync='pageData.page_size' :page.sync='pageData.current_page'
                              @pagination='getList' />
                <tips :data='tips'>

                </tips>
              </el-card>
              <el-card v-loading='dictLoading' class='db-card dict-card' shadow='hover'>
                <template slot='header'>
                  <div class='card-header'>
                    <span class='card-title'><i class='el-icon-tickets'></i>数据字典（全部表）</span>
                    <el-button type='text' icon='el-icon-refresh' :loading='dictLoading' @click='getTableCols'>
                      刷新
                    </el-button>
                  </div>
                </template>
                <div v-if='tableColsList.length' class='dict-list'>
                  <div v-for='(table,index) in tableColsList' :key='index' class='dict-item'>
                    <div class='dict-item-head'>
                      <span class='dict-table-name'>
                        <i class='el-icon-s-grid'></i>
                        {{ table.table_info.TABLE_NAME }}
                      </span>
                      <div class='dict-meta'>
                        <span class='dict-meta-item'>
                          <em>行数</em>{{ table.table_info.TABLE_ROWS != null
                            ? numberFormat(table.table_info.TABLE_ROWS, 0, '.', ',') : '-' }}
                        </span>
                        <span class='dict-meta-item'><em>自增ID</em>{{ table.table_info.AUTO_INCREMENT || '-' }}</span>
                        <span class='dict-meta-item'><em>引擎</em>{{ table.table_info.ENGINE || '-' }}</span>
                        <span class='dict-meta-item'>
                          <em>大小</em>{{ $utils.byteToSize(table.table_info.DATA_LENGTH) }}
                        </span>
                        <span class='dict-meta-item'>
                          <em>索引</em>{{ $utils.byteToSize(table.table_info.INDEX_LENGTH) }}
                        </span>
                        <span class='dict-meta-item'>
                          <em>碎片</em>{{ $utils.byteToSize(table.table_info.DATA_FREE) }}
                        </span>
                      </div>
                    </div>
                    <el-row :gutter='15'>
                      <el-col :lg='12' :md='12' :xs='24'>
                        <div class='dict-block'>
                          <ColumnTable :data-list='table.col_list' v-if='table.col_list'></ColumnTable>
                        </div>
                      </el-col>
                      <el-col :lg='12' :md='12' :xs='24'>
                        <div class='dict-block'>
                          <TableDataChart :table-name='table.table_info.TABLE_NAME'
                                          v-if='table.table_info.TABLE_NAME'></TableDataChart>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-else class='dict-empty'>
                  <i class='el-icon-document'></i>
                  <p>暂无数据字典，点击右上角“刷新”加载全部表结构</p>
                </div>
              </el-card>

            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 预览界面 -->
      <el-dialog :title='preview.title' :visible.sync='preview.open' width='80%' top='5vh' append-to-body
                 :close-on-click-modal='false'>
        <el-tabs v-model='preview.activeName'>
          <el-tab-pane
            v-for='(value, key) in preview.data'
            :label='key'
            :name='key'
            :key='key'
          >
            <div class='preview-toolbar'>
              <el-button type='primary' plain size='mini' icon='el-icon-document-copy'
                         @click.stop.native='copyData(value)'>复制
              </el-button>
            </div>
            <div class='preview-body'>
              <pre class='preview-code'>{{ value }}</pre>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </page-header-layout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ColumnTable from '@/pages/system/db/ColumnTable'
import TableDataChart from '@/pages/system/db/TableDataChart'
import {numberFormat} from "@/utils/utils";

export default {
  name: 'SystemDbIndex',
  components: { TableDataChart, ColumnTable, PageHeaderLayout },
  computed: {
    columns() {
      const cols = []
      Object.keys(this.colMap).forEach((k) => {
        //
        if (['DATA_FREE', 'INDEX_LENGTH', 'DATA_LENGTH'].indexOf(k) > -1) {
          const col = {
            title: this.colMap[k],
            field: k,
            value: `_${k}`,
            width: 120,
            align: 'right',
            sortable: 'custom'
          }
          cols.push(col)
        } else {
          cols.push({
            title: this.colMap[k],
            value: k,
            width: 120,
            align: 'center',
            sortable: 'custom'
          })
        }


      })
      return cols
    }
  },
  data() {
    return {
      loading: false,
      loadingStatus: false,
      dictLoading: false,
      searchCondition: { table_name: null },
      offset: 0,
      schema_data: {},//库新
      dataList: [],//表数据
      total: 0,
      pageData: { page_size: 10, current_page: 1 },
      tableColsList: [],//列数据
      orderSort: {},
      colMap: {
        // 'TABLE_CATALOG': '登记目录',
        // 'TABLE_SCHEMA': '所属库名',
        'TABLE_NAME': '表名称',
        'TABLE_COMMENT': '表的注释',
        // 'TABLE_TYPE': '表类型[system view|base table]',
        'ENGINE': '数据库引擎',//[MyISAM|CSV|InnoDB]
        // 'VERSION': '版本',//，默认值10
        // 'ROW_FORMAT': '行格式',//[Compact|Dynamic|Fixed]
        'TABLE_ROWS': '数据量（行）',
        'AVG_ROW_LENGTH': '平均行长度',
        'DATA_LENGTH': '数据长度',
        'MAX_DATA_LENGTH': '最大数据长度',
        'INDEX_LENGTH': '索引长度',
        'DATA_FREE': '空间碎片',
        // '_DATA_FREE': '空间碎片',
        'AUTO_INCREMENT': '自增主键当前值',
        'CREATE_TIME': '表的创建时间',
        'UPDATE_TIME': '表的更新时间',
        'CHECK_TIME': '表的检查时间',
        'TABLE_COLLATION': '表的字符校验编码集'
        // 'CHECKSUM': '校验和',
        // 'CREATE_OPTIONS': '创建选项',
        // 'TABLE_COMMENT': '表的注释、备注'
      },
      tips: [
        'Mysql数据库中的碎片主要来源于以下几个方面：',
        ' - 插入、更新和删除操作：当对索引列进行插入、更新和删除操作时，会导致索引数据的变动，从而产生碎片。特别是delete操作，会在存储中产生空白的空间，当有新数据插入时，MySQL会试图在这些空白空间中保存新数据，但是总是有部分空间不会被利用，久而久之就会导致碎片产生。\n',
        ' - 索引的删除和重建：当删除索引或重新构建索引时，原有的索引数据会被删除或重新生成，这也可能导致碎片的产生。\n',
        ' - 索引列的数据类型变更：如果对索引列的数据类型进行了变更，比如从INT变为VARCHAR，也会导致索引碎片的产生。\n',
        '以上情况都会导致Mysql数据库中的数据存储变得不连续、不规则，从而产生碎片'
      ],
      // 预览参数
      preview: {
        open: false,
        title: '代码预览',
        data: {},
        activeName: 'controller'
      },
      //筛选条件缓存key
      pageSearchKey:'page_search_key:system_db'

    }
  },
  methods: {
    numberFormat(value) {
      return numberFormat(value, 2, '.', ',', 'round')
    },
    async init() {
      if (sessionStorage.getItem(this.pageSearchKey)) {
        this.searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
      }

      this.loading = true
      try {
        await Promise.all([this.getInfo(), this.handleQuery()])
      } finally {
        this.loading = false
      }
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.orderSort = {}
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
      return this.getList()
    },
    changeTableSort({ prop, order }) {
      // let orderSort = {}
      if (order) {
        this.orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      // this.orderSort = orderSort
      this.getList()
    },
    async getInfo() {
      const { schema_data } = await this.$api.getSystemDbInfo()
      this.schema_data = schema_data
    },
    async getList() {
      this.loadingStatus = true
      try {
        const params = this.searchCondition
        Object.assign(params, this.pageData, { orderBy: this.orderSort })
        const { list, pages } = await this.$api.getSystemDbList(params)
        this.dataList = list
        this.pageData.current_page = pages.current_page || 1
        this.pageData.page_size = pages.page_size || 10
        this.total = pages.total || 0
        this.offset = pages.offset || 0
      } finally {
        this.loadingStatus = false
      }
    },
    async getTableCols() {
      if (this.dictLoading) {
        return
      }
      this.dictLoading = true
      try {
        const { list } = await this.$api.getSystemDbCols()
        this.tableColsList = list || []
      } finally {
        this.dictLoading = false
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleClick(row, column, event) {
      this.showTableDict(row.TABLE_NAME)
    },
    async showTableDict(table_name) {
      const { list } = await this.$api.getSystemDbCols({ table_name: table_name })
      this.tableColsList = list || []
    },
    //碎片优化
    async optimizeTable(row) {
      if (!row.TABLE_NAME) {
        this.$notify.warning('表名未知')
        return
      }
      if (row.DATA_FREE > 0) {

        this.$confirm('确定优化表碎片空间，请在业务不频繁的时候操作！！！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.$api.optimizeSystemDbTable({ table_name: row.TABLE_NAME })
          this.$notify.success('成功！')

        }).catch(() => {
          this.$notify.info('已取消')
        })

      } else {
        this.$notify.warning(`该表碎片大小为：${row.DATA_FREE}`)
      }
    },
    async getChartData(row) {
      await this.$api.getSystemDbTableChartData({ table_name: row.TABLE_NAME })
    },
    //预览
    async handlePreview(row) {

      const { data } = await this.$api.getSystemDbGenPreview(row.TABLE_NAME)
      this.preview.data = data
      this.preview.open = true
    },
    //复制到剪切板
    copyData(data) {

      const textarea = document.createElement('textarea')
      textarea.setAttribute('readonly', 'readonly')

      textarea.value = data
      document.body.appendChild(textarea)
      textarea.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        // alert('复制成功')
        this.$notify.success('已复制到剪切板')
      }
      document.body.removeChild(textarea)
    }

  },
  created() {
    this.init()
  }
}
</script>

<style scoped lang='scss'>
.db-page {
  box-sizing: border-box;
}

.db-page-body {
  box-sizing: border-box;
  min-height: 100%;
}

.db-card {
  margin-bottom: 15px;
  border: 1px solid #f2f2f2;
  border-radius: 8px;

  ::v-deep .el-card__header {
    padding: 12px 20px;
    border-bottom: 1px solid #f7f7f7;
    background: linear-gradient(90deg, #fff7f8 0%, #ffffff 55%);
  }

  ::v-deep .el-card__body {
    padding: 18px 20px;
  }
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #303133;

  i {
    margin-right: 6px;
    font-size: 18px;
    color: var(--primary);
  }
}

/* 数据库概览 */
.db-overview {
  margin-bottom: 6px;
}

.overview-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  min-height: 82px;
  margin-bottom: 12px;
  padding: 14px 18px;
  border: 1px solid #f2f2f2;
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  background: #ffffff;
  transition: box-shadow 0.2s, transform 0.2s;

  &:hover {
    box-shadow: 0 4px 14px rgba(255, 49, 118, 0.12);
    transform: translateY(-1px);
  }
}

.overview-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: #909399;
}

.overview-value {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  color: #303133;

  &.is-text {
    font-size: 18px;
    color: var(--primary);
  }
}

/* 分区标题 */
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 6px 0 12px;
  padding: 10px 0;
  border-bottom: 1px dashed #f2f2f2;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #303133;

  i {
    margin-right: 6px;
    color: var(--primary);
  }
}

.section-tip {
  display: flex;
  align-items: center;
  margin-top: 4px;
  font-size: 12px;
  color: #909399;

  i {
    margin-right: 4px;
    color: #c0c4cc;
  }
}

/* 搜索栏 */
.db-search {
  margin-bottom: 4px;
  padding: 12px 15px;
  border: 1px solid #f2f2f2;
  border-radius: 6px;
  background: #fafafa;

  ::v-deep .el-form-item {
    margin-bottom: 0;
    margin-right: 12px;
  }
}

.db-table {
  margin-top: 15px;

  ::v-deep .el-table__row {
    cursor: pointer;
  }
}

/* 数据字典 */
.dict-list {
  padding-right: 4px;
}

.dict-item {
  margin-bottom: 15px;
  padding: 15px;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  transition: border-color 0.2s;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: #ffd0df;
  }
}

.dict-item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #f2f2f2;
}

.dict-table-name {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: var(--primary);

  i {
    margin-right: 6px;
    color: #ff8bb0;
  }
}

.dict-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 16px;
  font-size: 12px;
  color: #606266;
}

.dict-meta-item {
  display: inline-flex;
  align-items: center;

  em {
    margin-right: 4px;
    font-style: normal;
    color: #909399;
  }
}

.dict-block {
  margin-bottom: 10px;
}

.dict-empty {
  padding: 50px 0;
  text-align: center;
  color: #909399;

  i {
    font-size: 42px;
    color: #dcdfe6;
  }

  p {
    margin-top: 10px;
    font-size: 13px;
  }
}

/* 代码预览 */
.preview-toolbar {
  margin-bottom: 10px;
  text-align: right;
}

.preview-body {
  height: 70vh;
  overflow: auto;
  border-radius: 6px;
  background: #f7f8fa;
}

.preview-code {
  margin: 0;
  padding: 15px;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.6;
  color: #303133;
  white-space: pre-wrap;
  word-break: break-all;
}

@media (max-width: 768px) {
  .section-tip {
    margin-top: 6px;
  }

  .overview-value {
    font-size: 20px;
  }

  .db-search {
    ::v-deep .el-form-item {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
